import React from 'react'

import PropTypes from 'prop-types'

import UserTabs from './UserTabs'

class SignUpWrapper extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="card">
        <UserTabs
          activeTabId={this.props.activeTabId}
          customId={this.props.customId}
          source={this.props.source}
          captchaId="navbar-captcha"
        />
      </div>
    )
  }
}

SignUpWrapper.propTypes = {
  activeTabId: PropTypes.string,
  customId: PropTypes.string.isRequired,
  source: PropTypes.string,
}

export default SignUpWrapper
